import { createConfirmation } from "react-confirm";
import AppendInventoryInfoDialog from "./AppendInventoryInfoDialog";

export const showAppendInventoryInfoDialog = createConfirmation(AppendInventoryInfoDialog);
